import React from 'react';

import styled from 'styled-components';
import muiStyled from '@mui/styles/styled';
import Select from 'react-select';
import TextField, { TextFieldProps } from '@mui/material/TextField';
import { DatePickerProps, DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { IconButtonProps } from '@mui/material/IconButton';
import { FormControl } from '@mui/material';
import { Styling, Colors } from '../../../constants';

const baseSelectHeight = '30px';
const baseSelectWidth = '90px';
const expandedSelectWidth = '230px';

export const selectClassPrefix = 'filter-select';

export const SelectItem = styled(Select)`
  width: ${baseSelectWidth};
  div.${selectClassPrefix}__control {
    overflow: hidden;
    top: 4px;
    height: ${baseSelectHeight};
    min-height: ${baseSelectHeight};
    background-color: ${Colors.INPUT_BACKGROUND};
    border: 1px ${Colors.BLACK_20} solid;
    div.${selectClassPrefix}__multi-value__label,
    div.${selectClassPrefix}__multi-value__remove {
      display: none;
    }
    div.${selectClassPrefix}__indicators,
    div.${selectClassPrefix}__value-container {
      height: ${baseSelectHeight};
      width: 100%;
    }
    div.${selectClassPrefix}__indicators {
      position: relative;
      top: -${baseSelectHeight};
      justify-content: flex-end;
      div.${selectClassPrefix}__clear-indicator {
        margin-right: 15px;
      }
    }
  }
  div.${selectClassPrefix}__control--is-focused {
    height: auto;
    max-height: 120px;
    overflow-y: scroll;
    width: ${expandedSelectWidth};
    z-index: 1;
    border: 2px solid ${Colors.RED_1};
    box-shadow: none;
    div.${selectClassPrefix}__multi-value__label,
    div.${selectClassPrefix}__multi-value__remove {
      display: block;
    }
    div.${selectClassPrefix}__value-container {
      height: auto;
      width: ${expandedSelectWidth};
    }
    div.${selectClassPrefix}__indicators {
      position: static;
      width: auto;
      div.${selectClassPrefix}__clear-indicator {
        margin-right: 0;
      }
    }
  }
  div.${selectClassPrefix}__control--is-disabled {
    pointer-events: auto;
    cursor: not-allowed !important;
  }
  div.${selectClassPrefix}__menu {
    width: ${expandedSelectWidth};
    border-radius: ${Styling.DEFAULT_BORDER_RADIUS}px;

    div.${selectClassPrefix}__menu-list {
      width: ${expandedSelectWidth};
      padding: ${Styling.DEFAULT_SPACING_HALVED}px;
      div.${selectClassPrefix}__option {
        border-left: 3px solid transparent;
        &:active {
          background-color: ${Colors.BLACK_15};
        }
      }
      div.${selectClassPrefix}__option--is-focused,
      div.${selectClassPrefix}__option--is-selected {
        background-color: ${Colors.BLACK_05};
      }
    }
  }
`;

export const TextFieldFilter = muiStyled(TextField)({
  width: '100%',
});

export const SmallTextFieldFilter = muiStyled(TextField)({
  maxWidth: '90px',
  minWidth: '90px',
});

export const DatePickerInputStyles: TextFieldProps['InputProps'] = {
  disableUnderline: true,
  style: {
    color: Colors.BLACK_80,
    fontSize: 12,
    fontWeight: 'bold',
    borderRadius: '3px',
    height: '30px',
    marginTop: '8px',
    border: `1px ${Colors.BLACK_20} solid`,
  },
};

export const DatePickerButtonProps: Partial<IconButtonProps> = {
  color: 'inherit',
  'aria-label': 'change date',
  size: 'small',
  edge: 'end',
};

export const DatePicker = muiStyled(MuiDatePicker)<DatePickerProps<Date>>({
  'border-radius': `${Styling.DEFAULT_BORDER_RADIUS}px`,
  'background-color': 'rgba(255, 255, 255, 0.25)',
  'max-width': '152px',
  'flex-grow': 1,
});

export const StyledFormControl = styled(FormControl)`
  &:has([id="Filters.orgTagIds"]) {
    margin-top: 12px;
    margin-right: 30px;
  }
`;
